$(document).ready(function(){
  
  if (window.outerWidth < 768) {
  
    $(".hero-content iframe").attr("width", 300).attr("height", 170);
  
  }
	$(".content-wrapper").hide();
  	$('.feature-link').hover(function(){
		var target = $(this).attr("data-feature-link");
		$(".features-links").find(".active").removeClass("active");
		$(this).addClass("active");
		$(".features-lists").find(".active").removeClass("active");
		$(".lists").find("[data-list='" + target + "']").addClass("active");
		$(".features-images").find(".active").removeClass("active");
		$(".features-images").find("[data-image='" + target + "']").addClass("active");
		
	});
  $(".cta-button").click(function(e){
    e.preventDefault();
  	 $('html, body').animate({
        scrollTop: $(".section.cta").offset().top
    }, 200);
  });
  $(".plan").find("select").change(function(){
    value = $(this).val();
    button = $(this).parent().find(".next-button");
    button.attr("href", value);
  });
   $(".next-button").click(function(e){
    if ($(this).attr("href") == "") {
      e.preventDefault();
      $(this).parent().parent().parent().css("height", "+=60");
      $(this).parent().find(".error").show();
    }
  });
});
// Make all the buttons/dropdowns at the same level
$(window).load(function(){
  var minHeight = 0;
  // // Find the tallest plan
    $(".plan").each(function(){
    if ($(this).height() > minHeight) {
      minHeight = $(this).height() + 20;
    }
    // // Make all the plans as tall as the tallest one
    $(this).css("height", minHeight);
  });
  });